import { type BaseApiErrorResponse, HttpStatus } from '../types/api.types';
import BaseApiResponseError from './BaseApiResponseError';

export type BadRequestArgs<TErrors> = Omit<
  BaseApiErrorResponse<TErrors>,
  'errors' | 'status'
>;
export default class BadRequest<TErrors> extends BaseApiResponseError<TErrors> {
  constructor({
    code,
    endDate,
    existingCheckIn,
    message,
    userMembershipId,
  }: BadRequestArgs<TErrors>) {
    super({
      code,
      endDate,
      errors: null,
      existingCheckIn,
      message,
      status: HttpStatus.BadRequest,
      userMembershipId,
    });
  }
}
